<template>
  <table style="width: 100%">
    <template v-for="(linha, index) in linhas">
      <linha
        :linha="linha"
        :dados="caracteristicasProduto"
        :key="index"
        :maximo-de-colunas="6"
      >
        <template #coluna.valor.idproduto="{valor}">
          <div class="d-flex align-center">
            <span>{{ valor }}</span>

            <ComparacaoProdutos
              v-if="produto.produto_eh_combinacao"
              :id_grupo="produto.id_grupo"
              :id_produto_combinado="produto.id_produto"
              :produtos="caracteristicasProduto.produtos"
              icon="mdi-information-outline"
              :size_icon="14"
              content_button_activator="ml-n2 my-n2"
            />
          </div>
        </template>

        <template v-slot:divisao_nivel_servico="{titulo}">
          <div class="d-flex align-center cursor-help" :title="nivelServico.descritivo">
            <span>{{titulo}}</span>

            <div
              id="bloco-nivel-servico"
              class="ml-1"
              :style="{background: nivelServico.cor}"
            ></div>
          </div>
        </template>

        <template v-slot:coluna.valor.filial>
          <template v-if="[9999, 0, null, undefined, 'Todas'].includes(produto.id_filial)">Todas</template>
          <template v-else>{{`Filial ${produto.id_filial}`}}</template>
        </template>

        <template v-slot:coluna.valor.fornecedor>
          <p class="ma-0 text-truncate cursor-help" style="width: 200px" :title="descricaoFornecedor">
            {{ descricaoFornecedor }}
          </p>
        </template>

        <template v-slot:coluna.valor.nivel_servico="{valor}">
           {{nivelServico.descricao}}
        </template>

        <template v-slot:coluna.valor.descricao_nivel_servico="{valor}">
          <div v-text="nivelServico.descritivo" class="text-wrap" />
        </template>

        <template #coluna.titulo.tempo_medio_apanhe="{texto}">
          <Legenda :titulo="texto" legenda="Consiste em medir a quantidade de vezes em média que uma determinada SKU da saída do estoque">
            <span v-text="texto" />
          </Legenda>
        </template>

        <template v-slot:coluna.valor.tempo_medio_apanhe="{valor}">
          {{ Helpers.formatarValor(valor) }}
        </template>

        <template #coluna.titulo.classificacao_financeira="{texto}">
          <Legenda :titulo="texto" legenda="Classificação voltada para área econômica, que visa segmentar de formas distintas a importância da aquisição de um determinado SKU, frente a seu custo de aquisição">
            <span v-text="texto" />
          </Legenda>
        </template>

        <template #coluna.titulo.classificacao_criticidade="{texto}">
          <Legenda :titulo="texto" legenda="Classificação voltada para o resultado comercial, que visa segmentar de formas distintas a importância comercial de um determinado SKU, frente ao faturamento geral">
            <span v-text="texto" />
          </Legenda>
        </template>

        <template #coluna.titulo.classificacao_comprabilidade="{texto}">
          <Legenda :titulo="texto" legenda="Classificação diz respeito ao processo de aquisição dos itens em estoque, incluindo tanto a identificação, qualificação e desenvolvimento de fornecedores como o disparo e atendimento de requisições, em termos do grau de confiabilidade das especificações e prazos">
            <span v-text="texto" />
          </Legenda>
        </template>

        <template #coluna.titulo.classificacao_popularidade="{texto}">
          <Legenda :titulo="texto" legenda="Classificação diz respeito a frequência de ocorrências de apanhes (pickings) envolvendo determinada SKU, observadas de um período pré-determinado, independentemente da quantidade envolvida em cada transação">
            <span v-text="texto" />
          </Legenda>
        </template>

        <template #coluna.titulo.perfil_demanda="{texto}">
          <Legenda :titulo="texto" legenda="Indica qual é o comportamento das intensidades de saídas do estoque distribuídas no tempo">
            <span v-text="texto" />
          </Legenda>
        </template>

        <template #coluna.titulo.desvio_padrao_consumo="{texto}">
          <Legenda :titulo="texto" legenda="O Desvio Padrão indica a Variabilidade de uma série de dados (no caso da Demanda). Quanto maior, mais dispersa (incerta) em torno da média">
            <span v-text="texto" />
          </Legenda>
        </template>

        <template #coluna.titulo.coeficiente_variacao="{texto}">
          <Legenda :titulo="texto" legenda="Coeficiente de Variação ou variabilidade é uma medida relativa de variabilidade que mede a dispersão entre o desvio Padrão e a média da demanda. Quanto maior, mais probabilística a demanda e quanto menor mais previsível">
            <span v-text="texto" />
          </Legenda>
        </template>
      </linha>
    </template>
  </table>
</template>

<script>
import ProdutoAPI from "../../../api/produto.js";
import linha from "./LinhaTabelaDetalhesProdutos";
import {converterEmbalagemValor} from "@/components/compra/ProdutosGerais/ConversorEmbalagem";
import Legenda from "@/components/produto/detalhes/Legenda";
import Heranca from "@/components/produto/detalhes/Acoes/Heranca/Index.vue";
import ComparacaoProdutos from "@/components/produto/DemandaCombinada/ComparacaoProdutos/Index.vue";

export default {
  name: "CaracteristicasProduto",
  components: {ComparacaoProdutos, Heranca, Legenda, linha},
  props: {
    produto: {
      type: Object,
      required: true
    },
    ativar_filtro_revenda_direta: Boolean,
  },
  data: () => ({
    caracteristicasProduto: {},
    linhas: [
      {
        colunas: [
          {texto: 'Código Interno', valor: 'idproduto'},
          {texto: 'Código Fornecedor', valor: 'cod_produto'},
          {texto: 'Nome do Produto', valor: 'descricao_produto', colspan: 2},
        ]
      },
      {
        colunas: [
          {texto: 'Grupo', valor: 'descricao_grupo'},
          {texto: 'Filial', valor: 'filial'},
          {texto: 'Fornecedor', valor: 'fornecedor'},
        ]
      },
      {
        divider: true,
        titulo: 'Nível de Serviço',
        nome: 'divisao_nivel_servico'
      },
      {
        colunas: [
          {texto: 'Nível', valor: 'nivel_servico'},
          {texto: 'Descrição', valor: 'descricao_nivel_servico', colspan: 3}
        ]
      },
      {
        divider: true
      },
      {
        colunas: [
          {texto: 'Custo de Aquisição', valor: 'classificacao_financeira'},
          {texto: 'Criticidade de Resultado', valor: 'classificacao_criticidade'},
          {texto: 'Comprabilidade', valor: 'classificacao_comprabilidade'},
          {texto: 'Frequência de Saída', valor: 'classificacao_popularidade'},
        ]
      },
      {
        colunas: [
          {texto: 'Unidade de Venda', valor: 'unidade_venda'},
          {texto: 'Unidade de Compra', valor: 'unidade_compra'},
          {texto: 'Perfil de Demanda', valor: 'perfil_demanda'}
        ]
      },
      {
        colunas: [
          // #zendesk-4571
          {texto: 'Frequência Média de Apanhe', valor: 'tempo_medio_apanhe', formatar: true},
          {texto: 'Desvio Padrão de Consumo', valor: 'desvio_padrao_consumo', formatar: true},
          {texto: 'Coeficiente de Variação', valor: 'coeficiente_variacao', formatar: true, append: '%'},
          {texto: 'Fator de conversão', valor: 'fator_conversao', formatar: true},
        ]
      }
    ]
  }),
  computed: {
    nivelServico() {
      const obj_padrao = {descricao: '-', descritivo: '-', cor: '#0D0D0D'};

      if (!this.caracteristicasProduto.status) return obj_padrao;

      const nivelProduto = this.Helpers.buscarObjetoStatus(this.caracteristicasProduto.status || '');

      return  nivelProduto[0] || obj_padrao;
    },
    descricaoFornecedor () {
      if (!this.caracteristicasProduto.idfornecedor) {
        return  '-';
      }

      const {idfornecedor, razao_social} = this.caracteristicasProduto;

      return `${idfornecedor} - ${razao_social}`;
    },
    EMBALAGEM_MASTER_ATIVO() {
      return this.$store.getters["EmbalagemTelaDeCompras/getEmbalagemMaster"];
    },
  },
  mounted() {
    this.getCaracteristicasProduto();
  },
  methods: {
    getCaracteristicasProduto() {
      const {id_produto, id_grupo, id_filial, produto_eh_combinacao, produto_eh_categoria} = this.produto;

      this.$store.dispatch(
        "loading/addRequisicao",
        ProdutoAPI.getCaracteristicasProduto(
          id_produto,
          id_grupo,
          id_filial,
          (produto_eh_combinacao ? 'S' : 'N'),
          (produto_eh_categoria ? 'S' : 'N'),
          (this.ativar_filtro_revenda_direta ? 'S' : 'N'),
        )
          .then(response => {
            const {token, caracteristicas} = response.data;
            localStorage.token = token;
            this.caracteristicasProduto = caracteristicas;
          })
          .catch(() => (this.Helpers.logout()))
      );
    },
    converterEmbalagemValor(valor) {
      if (!this.caracteristicasProduto.tipo_fator_conversao || !this.EMBALAGEM_MASTER_ATIVO) {
        return valor;
      }

      return converterEmbalagemValor(this.caracteristicasProduto, valor);
    }
  }
}
</script>

<style scoped>
#bloco-nivel-servico {
  height: 15px;
  width: 15px;
  /*border-radius: 50%;*/
}
</style>
